import { useState } from "react";
import { Box, Paper, Tabs, Tab } from "@mui/material";
import { Add as AddIcon, Search as SearchIcon } from "@mui/icons-material";
import NewSheetTab from "./NewSheetTab";
import LoadSheetTab from "./LoadSheetTab";
import { Customer, Location, InspectionData, SearchFilters } from "../../Types/InspectionTypes";

interface SheetSelectorProps {
    customers: Customer[];
    locations: Location[];
    onLoadSheet: (inspectionId: number) => void;
    onSearch: (filters: SearchFilters) => Promise<InspectionData[]>;
    onTabChange?: (tabIndex: number) => void;
    isMobile?: boolean;
    isAdmin?: boolean;
    onDeleteSheet?: (inspectionId: number) => Promise<void>;
}

export type { SearchFilters };

const SheetSelector = ({
    customers,
    locations,
    onLoadSheet,
    onSearch,
    onTabChange,
    isMobile = false,
    isAdmin = false,
    onDeleteSheet,
}: SheetSelectorProps) => {
    const [activeTab, setActiveTab] = useState<number>(0); // 0 = new, 1 = load

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
        // Notify parent component about tab change
        if (onTabChange) {
            onTabChange(newValue);
        }
    };

    return (
        <Paper elevation={3} sx={{ mb: 3 }}>
            <Tabs
                value={activeTab}
                onChange={handleTabChange}
                variant="fullWidth"
                sx={{
                    borderBottom: 1,
                    borderColor: 'divider',
                    backgroundColor: 'primary.main',
                    '& .MuiTab-root': {
                        color: 'rgba(255, 255, 255, 0.7)',
                        fontWeight: 600,
                    },
                    '& .Mui-selected': {
                        color: 'white !important',
                    },
                    '& .MuiTabs-indicator': {
                        backgroundColor: 'white',
                        height: 3,
                    },
                }}
            >
                <Tab icon={<AddIcon />} label="New Sheet" iconPosition="start" />
                <Tab icon={<SearchIcon />} label="Load Sheet" iconPosition="start" />
            </Tabs>

            <Box sx={{ p: isMobile ? 2 : 3 }}>
                {activeTab === 0 ? (
                    <NewSheetTab isMobile={isMobile} />
                ) : (
                    <LoadSheetTab
                        customers={customers}
                        locations={locations}
                        onLoadSheet={onLoadSheet}
                        onSearch={onSearch}
                        isMobile={isMobile}
                        isAdmin={isAdmin}
                        onDeleteSheet={onDeleteSheet}
                    />
                )}
            </Box>
        </Paper>
    );
};

export default SheetSelector;
